<template>
  <AppButtonOk @click="$emit('click')">
    コピーして作成
  </AppButtonOk>
</template>

<script>
export default {
  name: 'SimulationFooterReadonlyButtonCopy',
}
</script>

<style scoped></style>
